import React from "react";
import { motion } from "framer-motion";
import { IMAGES } from "@/lib/media";
import { MaskReveal, Reveal } from "@/components/motion/Reveal";

const SETS = [
  { title: "Ibiza Lounge", tag: "Deep House · Live Percussion", img: IMAGES.experienceLounge, span: "lg:col-span-7 lg:row-span-2", h: "min-h-[420px] lg:min-h-full" },
  { title: "Festival Mainstage", tag: "Big Room · Total Experience", img: IMAGES.experienceFestival, span: "lg:col-span-5", h: "min-h-[280px]" },
  { title: "Feel-Good & Party Hits", tag: "Anthems · Sing-Along Energy", img: IMAGES.decks, span: "lg:col-span-5", h: "min-h-[280px]" },
];

export const Experience = () => {
  return (
    <section id="experience" className="relative py-28 lg:py-40 px-6 lg:px-16 max-w-[1400px] mx-auto">
      <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-16">
        <div>
          <Reveal><span className="text-xs uppercase tracking-[0.4em] text-gold">The Experience</span></Reveal>
          <h2 className="mt-4 font-display text-6xl sm:text-7xl lg:text-8xl leading-[0.85] tracking-wide text-white">
            <MaskReveal>EVERY ROOM,</MaskReveal>
            <MaskReveal delay={0.1}>EVERY <span className="text-magenta">VIBE</span></MaskReveal>
          </h2>
        </div>
        <Reveal delay={0.2}>
          <p className="max-w-sm text-white/60 leading-relaxed">
            From dreamy lounge soundscapes to the most explosive dance beats — her dynamic mix of DJ-ing, live percussion and on-the-spot improvisation lifts every event to the next level.
          </p>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-5 auto-rows-fr">
        {SETS.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.1} className={s.span}>
            <div className={`group relative ${s.h} h-full overflow-hidden rounded-2xl`}>
              <motion.img
                src={s.img}
                alt={s.title}
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink-950 via-ink-950/20 to-transparent" />
              <div className="absolute inset-0 ring-1 ring-inset ring-white/10 rounded-2xl group-hover:ring-magenta/50 transition-all duration-500" />
              <div className="absolute bottom-6 left-6 right-6">
                <p className="text-[10px] uppercase tracking-[0.3em] text-gold mb-1">{s.tag}</p>
                <h3 className="font-display text-4xl lg:text-5xl tracking-[0.1em] text-white">{s.title}</h3>
              </div>
            </div>
          </Reveal>
        ))}

        {/* Brand activations text tile */}
        <Reveal delay={0.3} className="lg:col-span-12">
          <div className="glass rounded-2xl px-8 py-10 flex flex-col md:flex-row md:items-center justify-between gap-6">
            <div>
              <h3 className="font-display text-4xl tracking-[0.1em] text-white">CORPORATE & BRAND ACTIVATIONS</h3>
              <p className="mt-2 text-white/60 max-w-xl">A strong first impression is everything. DaniQ elevates your brand and corporate event with a strategic play of music, rhythm and energy — the perfect soundtrack for launches and impactful experiences.</p>
            </div>
            <div className="flex gap-3 flex-wrap">
              {["Top 40 & Disco", "Deep House", "Latin Beats", "Live Drums"].map((t) => (
                <span key={t} className="rounded-full border border-white/15 px-4 py-2 text-xs uppercase tracking-[0.15em] text-white/70">{t}</span>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
